<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <ng-container>
        <li class="menu-title"> {{ "SIDEBAR.menu" | translate }}</li>
        <li [ngClass]="{ 'mm-active' : isActive('/products') }">
          <a (click)="toggleMenu($event)" routerLink="/products" class="side-nav-link-ref">
            <i class="bx bxl-dropbox"></i>
            <span>   {{ "SIDEBAR.products" | translate }} </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/users') }">
          <a (click)="toggleMenu($event)" routerLink="/users" class="side-nav-link-ref">
            <i class="bx bx-user-circle"></i>
            <span>  {{ "SIDEBAR.users" | translate }} </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/roles') }">
          <a (click)="toggleMenu($event)" routerLink="/roles" class="side-nav-link-ref">
            <i class="bx bxs-user-badge"></i>
            <span>  {{ "SIDEBAR.roles-n-permissions" | translate }} </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/email-template') }">
          <a (click)="toggleMenu($event)" routerLink="/email-template" class="side-nav-link-ref">
            <i class="bx bx-brush"></i>
            <span>  {{ "SIDEBAR.email-templates" | translate }} </span>
          </a>
        </li>

        <!-- <li [ngClass]="{ 'mm-active' : isActive('/archive') }">
          <a routerLink="/archive" class="side-nav-link-ref">
            <i class="bx bx-archive"></i>
            <span>  {{ "SIDEBAR.archive" | translate }} </span>
          </a>
        </li> -->

        <li [ngClass]="{ 'mm-active' : isActive('/translations') }">
          <a (click)="toggleMenu($event)" routerLink="/translations" class="side-nav-link-ref">
            <i class="bx bx-globe"></i>
            <span>  {{ "SIDEBAR.translations" | translate }} </span>
          </a>
        </li>

        <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : (isActive('/changelog-version') || isActive('/manuals') || isActive('/faqs')) }">
          <a href="javascript:void(0);"
            class="is-parent has-arrow ng-star-inserted mm-collapsed" aria-expanded="false">
            <i class="bx bx-support"></i>
            <span> {{ "SIDEBAR.help-n-support" | translate }} </span>
          </a>
          <ul aria-expanded="false" class="sub-menu ng-star-inserted mm-collapse">
            
            <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/manuals') }">
              <a class="side-nav-link-ref ng-star-inserted" routerLink="/manuals">  {{ "SIDEBAR.manual" | translate }} </a>
            </li>
            
            <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/changelog-version') }">
              <a class="side-nav-link-ref ng-star-inserted" routerLink="/changelog-version">  {{ "SIDEBAR.changelog" | translate }} </a>
            </li>

            <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/faqs') }">
              <a class="side-nav-link-ref ng-star-inserted" routerLink="/faqs">  {{ "SIDEBAR.faqs" | translate }} </a>
            </li>

          </ul>
        </li>

        <li class="ng-star-inserted">
          <a href="javascript:void(0);"
            class="is-parent has-arrow ng-star-inserted mm-collapsed" aria-expanded="false">
            <i class="bx bx-cog"></i>
            <span> {{ "SIDEBAR.settings" | translate }} </span>
          </a>
          <ul aria-expanded="false" class="sub-menu ng-star-inserted mm-collapse">
            
            <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/tags') }">
              <a class="side-nav-link-ref ng-star-inserted" routerLink="/tags">  {{ "SIDEBAR.tags" | translate }} </a>
            </li>

            <li class="ng-star-inserted">
              <a class="side-nav-link-ref ng-star-inserted cursor-pointer" (click)="gotoLogs()">  {{ "SIDEBAR.system-logs" | translate }} </a>
            </li>

          </ul>
        </li>

      </ng-container>
    </ul>`
  </div>

  <div class="sidebar-footer">
    <!-- <span class="w-100 cursor-pointer" routerLink="/changelog-version"> {{ "SIDEBAR.version" | translate }}  0.0.1</span> -->
  </div>
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    @if(isCondensed){
    <div>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    }@else {
    <div>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    }
  </ngx-simplebar>
</div>
<!-- Left Sidebar End -->